var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFloatingClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.6572,
    y: 5,
    width: 2,
    height: 18,
    transform: "rotate(45 17.6572 5)",
    fill: "var(--report-widget-icon-stroke-dark)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.0713,
    y: 18,
    width: 2,
    height: 18,
    transform: "rotate(135 19.0713 18)",
    fill: "var(--report-widget-icon-stroke-dark)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFloatingClose);
export default __webpack_public_path__ + "static/media/icon-floating-close.e17e7a8e1232bbafefbf9f8705b55953.svg";
export { ForwardRef as ReactComponent };